import * as React from "react";
import { useNavigate } from "react-router-dom";

import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid2';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';

import dayjs from 'dayjs';
import { useDispatch, useSelector } from 'react-redux';

import PageShell from './layout/PageShell';
import { ShellContext } from './layout/AppShell';
import HomePrincipalCards from "./HomePrincipalCards";
import LastReceiptsList from './LastReceiptsList';
import HomeAreaChart from './HomeAreaChart';
import SalesHeatMap from "./SalesHeatMap";
import GettingStarted from './GettingStarted';

import useAxios from '../utils/useAxios';
import { setHomeTimeInterval, setYearReceiptsDaily } from '../actions';

const PERIODS = [
  { value: 'day', label: 'Día' },
  { value: 'week', label: 'Semana' },
  { value: 'month', label: 'Mes' },
  { value: 'year', label: 'Año' },
];

const greeting = () => {
  const hour = dayjs().hour();
  if (hour < 12) return 'Buenos días';
  if (hour < 19) return 'Buenas tardes';
  return 'Buenas noches';
};

const Home = () => {
  const axios = useAxios();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { membership } = React.useContext(ShellContext);
  const homeTimeInterval = useSelector((state: any) => state.homeTimeInterval);

  React.useEffect(() => {
    const fetchYearReceipts = async () => {
      try {
        const { data } = await axios.get('api/receipts/summary/', {
          params: {
            start_date: dayjs().startOf('year').utc().format(),
            end_date: dayjs().endOf('year').utc().format(),
            granularity: 'day',
            time_series: true,
          },
        });
        dispatch(setYearReceiptsDaily(data));
      } catch (error) {
        console.log(error);
      }
    };
    fetchYearReceipts();
  }, [axios, dispatch]);

  const firstName = membership?.name?.split(' ')[0];
  const today = dayjs().format('dddd, D [de] MMMM');

  return (
    <PageShell
      title={firstName ? `${greeting()}, ${firstName}` : greeting()}
      subtitle={today.charAt(0).toUpperCase() + today.slice(1)}
      actions={
        <>
          <ToggleButtonGroup
            size="small"
            exclusive
            value={homeTimeInterval}
            onChange={(_, value) => value && dispatch(setHomeTimeInterval(value))}
            aria-label="Periodo"
            sx={{ bgcolor: 'background.paper', '& .MuiToggleButton-root': { px: 1.75, textTransform: 'none', fontWeight: 600 } }}
          >
            {PERIODS.map(p => <ToggleButton key={p.value} value={p.value}>{p.label}</ToggleButton>)}
          </ToggleButtonGroup>
          <Button
            variant="contained"
            startIcon={<AssessmentOutlinedIcon />}
            onClick={() => navigate(`/admin/daily-report/${dayjs().format('YYYY-MM-DD')}`)}
          >
            Reporte del día
          </Button>
        </>
      }
    >
      <GettingStarted />
      <HomePrincipalCards />
      <Grid container spacing={3} sx={{ mt: 3 }}>
        <Grid size={{ xs: 12, lg: 8 }}>
          <HomeAreaChart />
        </Grid>
        <Grid size={{ xs: 12, lg: 4 }}>
          <LastReceiptsList k={10} />
        </Grid>
        <Grid size={12}>
          <SalesHeatMap />
        </Grid>
      </Grid>
    </PageShell>
  );
};

export default Home;
